import { observer } from 'mobx-react';
import React from 'react';
import placementTestReportStudentsListService from '../services/PlacementTestReportStudentsListService';
import placementTestReportTestDialogService from '../services/PlacementTesReportTestDialogService';
import PlacementTestReportStudentsList from './PlacementTestReportStudentsList';

function PlacementTestReportStudentsListContainer() {
  return (
    <PlacementTestReportStudentsList
      data={placementTestReportStudentsListService.data}
      isFetching={placementTestReportStudentsListService.fetch.fetching}
      pagination={placementTestReportStudentsListService.pagination}
      onChange={placementTestReportStudentsListService.load}
      onOpen={placementTestReportTestDialogService.handleOpenDialog}
      sort={placementTestReportStudentsListService.sort}
    />
  );
}

export default observer(PlacementTestReportStudentsListContainer);
